export default {
  countryFormControl: { display: 'flex', flexDirection: 'row', alignItems: 'center', minWidth: 90, marginRight: 2 },
  yearFormControl: { display: 'flex', flexDirection: 'row', alignItems: 'center', minWidth: 70 },
  formControls: { display: 'flex', color: '#9E9E9E' },
  inputLabel: { marginRight: '5px', fontSize: '14px', fontWeight: 400 },
  selectBox: { minWidth: 100 }
}
